import {defineStore} from 'pinia'
import store from "store";
// import useAuthnStore from "@/store/authn";
// import Vue from "vue";


const formStore = defineStore('form-store', {
    state: () => ({
        form: store.get('form') || undefined,
        ...store.get('form')
    }),
    getters: {
        getForm(state) {
            return state.form;
        },
    },
    actions: {
        setForm(form) {
            console.log("form")
            console.log(form)
            this.form = form;
            store.set("form",form)
        }
    },
})

export default formStore;
